// React y Router Importaciones
import React, { useEffect, useState } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";

// Swiper CSS imports
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Swiper bundle registration
import { register } from "swiper/element/bundle";

// CSS imports
import "./App.css";

// Components
import Boton from "./components/Boton";
import Footer from "./components/Footer";
import ImageSlider from "./components/ImageSlider";
import SliderTop from "./components/SliderTop";
import TitleSubtitle from "./components/TitleSubtitle";
import TopHeader from "./components/TopHeader";
import TourSlider from "./components/TourSlider";

// Pages
import Contactanos from "./pages/Contactanos";
import LibroReclamaciones from "./pages/LibroReclamaciones";
import Nosotros from "./pages/Nosotros";
import Paquete from "./pages/Paquete";
import Paquetes from "./pages/Paquetes";
import Politicas from "./pages/Politicas";
import ProteccionNinosAdolescentes from "./pages/ProteccionNinosAdolescentes";
import TerminosCondiciones from "./pages/TerminosCondiciones";
import Tour from "./pages/Tour";
import Tours from "./pages/Tours";

// Images
import castilloImg1 from "./images/images-header/20150627_111505.jpg";
import rioAmazonasDesc from "./images/images-header/20190611_152722.jpg";
import Ahuahiaco from "./images/images-header/Ahuahiaco.jpg";
import carpisuyacu from "./images/images-header/Carpisuyacu.jpg";
import lagunaAzul from "./images/images-header/IMG_5427.jpg";
import taytamaky from "./images/images-header/Taytamaky.jpg";
import logoImage from "./images/images-logo/imagotipoTarapotoColor.png";

// Custom hooks
import VerticalSeparator from "./components/VerticalSeparator";
import useFadeIn from "./hooks/useFadeIn";
import useScrollToTop from "./hooks/useScrollToTop";
import CertificadoDircetur from "./pages/CertificadoDircetur";

register();

const sliderImages = [
  { url: taytamaky, span1: "Mirador", title: "Tarapoto", position: "top-right" },
  {
    url: castilloImg1,
    span1: "Castillo de",
    title: "Lamas",
    position: "top-right",
  },
  {
    url: carpisuyacu,
    span1: "Cascada",
    title: "CARPISHUYACU",
    position: "bottom-left",
  },
  { url: lagunaAzul, span1: "Laguna", title: "Azul", position: "bottom-right" },
  { url: Ahuahiaco, span1: "", title: "Ahuashiyacu", position: "top-right" }
];

function App() {
  useScrollToTop();
  useFadeIn();
  const [isHovered, setIsHovered] = useState(false); //por si queremos hacer el cuerpo oscuro al hoverear, sino eliminar
  const location = useLocation();
  const [pageKey, setPageKey] = useState(location.pathname);

  useEffect(() => {
    if (pageKey !== location.pathname) {
      // console.log("Actualizando pageKey de:", pageKey, "a:", location.pathname);
      setPageKey(location.pathname);
    }
  }, [location.pathname]);

  return (
    <div key={pageKey} className={`App ${isHovered ? "darkened" : ""}`}>
      <div className="todoheader">
        <TopHeader />
      </div>
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <SliderTop sliderImages={sliderImages} />
              <div className="full-width-container">
                <div className="centered-container">
                  <img
                    src={logoImage}
                    alt="Fada Tours, Feliz aventura disfrutando la amazonía"
                    className="responsive-image fade-in"
                  />
                </div>
              </div>
              {/* <TitleSubtitle
                title="FADA TOURS"
                subtitle="Los mejores tours de la región"
                backgroundTitle="Quienes somos"
                position="centro"
              /> */}
              {/* <Par position="centro">
                Fada Tours es una empresa de turismo especializada en ofrecer
                experiencias únicas en Tarapoto, destacando la belleza natural y
                cultural de la región. Su misión es brindar servicios de
                calidad, asegurando recuerdos inolvidables para todos sus
                visitantes.
              </Par> */}
              <VerticalSeparator altura="1" />
              <Boton
                to="/nosotros"
                texto="Descubre quienes somos"
                type="secondary-invertido"
                position="centro"
              />
              <TitleSubtitle
                title="Conoce nuestros Paquetes"
                position="centro"
              />
              <ImageSlider />
              <Boton
                to="/paquetes"
                texto="Ver más PAQUETES"
                type="primary-invertido"
                position="centro"
              />
              <div className="bg-inner-shadow">
                <TourSlider title="Tours"/>
              </div>
            </div>
          }
        />

        {/* Ruta de la página de Tours */}
        <Route path="/tours" element={<Tours />} />
        <Route path="/paquetes" element={<Paquetes />} />
        <Route path="/paquete/:nombre" element={<Paquete />} />
        <Route path="/contacto" element={<Contactanos />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/politicas" element={<Politicas />} />
        <Route path="/terminos" element={<TerminosCondiciones />} />
        <Route path="/proteccionMenores" element={<ProteccionNinosAdolescentes />} />
        <Route path="/certificadoDircetur" element={<CertificadoDircetur />} />
        <Route
          path="/tours/:link"
          element={<Tour key={window.location.pathname} />}
        />
        <Route path="/libroreclamaciones" element={<LibroReclamaciones />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
